import { render } from "./CreatedDate.vue?vue&type=template&id=61856cc3"
import script from "./CreatedDate.vue?vue&type=script&lang=js"
export * from "./CreatedDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__